import es from './es/messages';
import en from './en/messages';
import fr from './fr/messages';

export default {
  es,
  en,
  fr
};



// WEBPACK FOOTER //
// ./src/lang/index.js